
import { defineComponent } from 'vue';
import { useList } from '@/hooks/use-list';
import { SUCCESSFUL_LIST } from './constant/index';
import type { ISsoLogPageResListItem, ISsoLogPageReq } from '@/api/message-center/type.d';
import { getSsoCenterList } from '@/api/message-center';
import usePermissionConfig from './use-permission-config';
import { formatTime } from '@toy/utils';
import dayjs from 'dayjs';

export default defineComponent({
  setup() {
    const permissionConfig = usePermissionConfig();
    const {
      params,
      tableTotal,
      tableData,
      handleSizeChange,
      handleCurrentChange,
      handleReset,
      handleSearch,
    } = useList<ISsoLogPageResListItem, ISsoLogPageReq>({
      request: {
        api: getSsoCenterList,
        params: {
          code: '',
          requestParams: '',
          startRequestTime: '',
          endRequestTime: '',
          pageNum: 1,
          pageSize: 10,
          createdTime: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD HH:mm:ss')],
        },
        handleParams(paramsObj) {
          // 处理时间
          if (paramsObj.createdTime?.length === 2) {
            [
              paramsObj.startRequestTime,
              paramsObj.endRequestTime,
            ] = paramsObj.createdTime;
            paramsObj.startRequestTime = `${
              formatTime(paramsObj.startRequestTime, 'YYYY-MM-DD HH:mm:ss')
            }`;
            paramsObj.endRequestTime = `${
              formatTime(paramsObj.endRequestTime, 'YYYY-MM-DD HH:mm:ss')
            }`;
          } else {
            const endRequestTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
            const startRequestTime = dayjs().format('YYYY-MM-DD');
            [
              paramsObj.startRequestTime, paramsObj.endRequestTime,
            ] = [formatTime(startRequestTime, 'YYYY-MM-DD HH:mm:ss'),
              formatTime(endRequestTime, 'YYYY-MM-DD HH:mm:ss')];
          }
          // 处理参数
          if (typeof paramsObj.successful !== 'boolean') {
            delete paramsObj.successful;
          }
          delete paramsObj.createdTime;
          return paramsObj;
        },
      },
    });
    const init = () => {
      handleSearch();
    };

    init();
    return {
      params,
      tableTotal,
      tableData,
      handleSizeChange,
      handleCurrentChange,
      handleReset,
      handleSearch,
      permissionConfig,
      SUCCESSFUL_LIST,
    };
  },

});

